import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

const CLAIMS_PATH = '/api/Claims';

// Claims
export const getClaimsGrid = (params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/Grid${getQueryParams(params)}`));

// Claim by Id
export const getClaim = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}`));
export const saveClaim = (claim) => makeRequest(authFetch.put(CLAIMS_PATH, claim));

// Claimants
export const getClaimants = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/claimants`));
export const getOtherClaimants = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/other-claimants`));
export const saveClaimant = (claimId, data) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/other-claimants`, data));
export const deleteClaimantById = ({ claimId, claimantId }) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}`));
export const deleteOtherClaimantById = ({ claimId, claimantId }) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/other-claimants/${claimantId}`));

// Adjusters
export const getAdjusters = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/adjusters`));
export const saveAdjuster = (claimId, data) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/adjusters`, data));
export const deleteAdjusterById = ( claimId, adjusterId ) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/adjusters/${adjusterId}`));

export const getDriverTrucks = (driverId) => makeRequest(authFetch.get(`/api/driverTrucks/${driverId}`));

// Claimants Passengers
export const getClaimantPassengers = (claimId, claimantId) => makeRequest(authFetch
  .get(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/passengers`));

export const saveClaimantPassenger = (claimId, claimantId, data) => makeRequest(
  authFetch.put(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/passengers`, data),
);
export const deleteClaimantPassengersById = (claimId, claimantId, passengerId) => makeRequest(
  authFetch.delete(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/passengers/${passengerId}`),
);

// Claimants Owners
export const getClaimantOwners = (claimId, claimantId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/owners`));

export const saveClaimantOwner = (claimId, claimantId, data) => makeRequest(
  authFetch.put(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/owners`, data),
);
export const deleteClaimantOwnerById = (claimId, claimantId, ownerId) => makeRequest(
  authFetch.delete(`${CLAIMS_PATH}/${claimId}/claimants/${claimantId}/owners/${ownerId}`),
);

// Witnesses
export const getWitnesses = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/witnesses`));
export const saveWitness = (claimId, data) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/witnesses`, data));
export const deleteWitnessById = (claimId, witnessId) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/witnesses/${witnessId}`));

// Police
export const getPoliceList = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/police`));
export const savePolice = (claimId, data) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/police`, data));
export const deletePoliceById = (claimId, policeId) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/police/${policeId}`));

// Wrecker / Other vendors
export const getCompanies = (claimId) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/companies`));
export const saveCompany = (claimId, data) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/companies`, data));
export const deleteCompanyById = (claimId, companyId) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/companies/${companyId}`));

// Stats
export const getClaimStatsByLocation = (params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/stats/byLocation${getQueryParams(params)}`));
export const getClaimStatsByDate = (params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/stats/byDate${getQueryParams(params)}`));
export const getAutoClaimStatsKPIs = (params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/stats/kpis${getQueryParams(params)}`));

// Statics and lookups
export const getClaimLocationTypes = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimLocationTypes`));
export const getClaimLocationSetups = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimLocationSetups`));
export const getTravellingDirections = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/TravellingDirections`));
export const getWeatherConditions = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/WeatherConditions`));
export const getClaimTypes = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimTypes`));
export const getClaimStatuses = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimStatuses`));
export const getClaimDeterminations = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimDeterminations`));
export const getClaimRootCauses = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimRootCauses`));
export const getClaimContributingFactors = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimContributingFactors`));
export const getClaimCreatedByOptions = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/ClaimCreatedByOptions`));

// Attachments
export const getClaimFileTypes = () => makeRequest(authFetch.get(`${CLAIMS_PATH}/file-types`));
export const getClaimFiles = (claimId, params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/files${getQueryParams(params)}`));
export const postClaimFiles = (claimId, files) => makeRequest(authFetch.post(`${CLAIMS_PATH}/${claimId}/files`, files));
export const deleteClaimFile = (claimId, fileId) => makeRequest(authFetch.delete(`${CLAIMS_PATH}/${claimId}/files/${fileId}`));
export const putClaimFile = (claimId, fileId, file) => makeRequest(authFetch.put(`${CLAIMS_PATH}/${claimId}/files/${fileId}`, file));

// Notes
export const getClaimNotes = (claimId, params) => makeRequest(authFetch.get(`${CLAIMS_PATH}/${claimId}/notes${getQueryParams(params)}`));
export const pinClaimNote = (claimId, noteId, pinState) => makeRequest(authFetch.patch(`${CLAIMS_PATH}/${claimId}/notes/${noteId}/pin`, pinState));
export const patchClaimNote = (claimId, note) => makeRequest(authFetch.patch(`${CLAIMS_PATH}/${claimId}/notes`, note));
